(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilter', rmsListFilter);

    function rmsListFilter() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                hideFilter: '=?',
                setExternalFilter: '=?',
                gridRefresh: '&?'
            },
            controller: rmsListFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/list-filter'
        };
    }

    function rmsListFilterCtrl(ListFilterService, $scope, lodash, ListFilterStateFactory) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.pageData = {
                sidebar_active: false,
                bulk_action_active: false,
                use_bulk_action: lodash.get(vm.options, 'toolbar.side_bulk_action.setting', false),
            };
            vm.setExternalFilter = setExternalFilter;
            vm.hasActiveFilters = hasActiveFilters;

            var hideFilter = lodash.get(vm.options, 'hideFilter', false);

            if (hideFilter === true) {
                vm.hideFilter = hideFilter;
            }

            $scope.$on('$destroy', destroyFunc);
            init();
        }

        function destroyFunc() {
            ListFilterStateFactory.destroy($scope.listFilterIdentifier);
        }

        function init() {
            $scope.listFilterService = new ListFilterService();
            $scope.listFilterService.init(vm.pageData, angular.copy(vm.options), $scope);
            ListFilterStateFactory.create($scope.listFilterService, $scope.listFilterIdentifier);

            if (typeof vm.gridRefresh === typeof function () {
            }) {
                $scope.listFilterService.setExternalGridRefreshFunc(vm.gridRefresh);
            }
        }

        function setExternalFilter(refreshGrid, status) {
            $scope.listFilterService.clearSelected();
            if (status) {
                vm.pageData.filters.active_filters.pipeline = status;
            }
            if (!status) {
                vm.pageData.filters.active_filters.pipeline = null;
            }
            $scope.listFilterService.updateToolbarButtons(status);
            if (refreshGrid) {
                $scope.listFilterService.refreshGrid(true);
            }
        }

        function hasActiveFilters() {
            return $scope.listFilterService.getFilterService().hasAppliedFilters();
        }
    }
})();
